/* lua.js generated code 0.3.0 */

require("clover/panelBusLogic/PaymentLimitLogic")
var UserDealPayTypeBase = require("clover/logic/userDeal/UserDealPayTypeBase")
var UserDealPayTypeIngame = xClass("UserDealPayTypeIngame", UserDealPayTypeBase)
UserDealPayTypeIngame.prototype.canBuyGoods = function (goodsId, num) {
    var self = this
    if (!PlatformConfig.isIngamePaySupport()) {
        // FIXME: multi result
        return [false, ZooErrorCode.PAY_TYPE_UNSUPPORT]
    }
    var payment = self.getPaymentsType()
    if (!payment) {
        // FIXME: multi result
        return [false, ZooErrorCode.PAY_TYPE_UNSUPPORT]
    }
    require("hecore/debug/remote")
    RemoteDebug.uploadLog("CheckLimit", tostring(payment), table.tostring(PaymentLimitLogic.getPaymentLimitInfo(payment)))
    if (PaymentLimitLogic.isExceedDailyLimit(payment)) {
        // FIXME: multi result
        return [false, ZooErrorCode.PAY_EXCEED_DAILY_LIMIT]
    } else if (PaymentLimitLogic.isExceedMonthlyLimit(payment)) {
        // FIXME: multi result
        return [false, ZooErrorCode.PAY_EXCEED_MONTHLY_LIMIT]
    }
    return [true,null]
}
UserDealPayTypeIngame.prototype.getPaymentsType = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // WARN: maybe multi result
    return GameProxy.getInstance().getDefaultSmsPayment()
}
module.exports = UserDealPayTypeIngame
